export interface Report {
  id: string;
  title: string;
  summary: string;
  category: string;
  categoryLabel: string;
  date: string;
  readTime: number;
  isHot: boolean;
  isFeatured: boolean;
  imageUrl: string;
  imageAlt: string;
  content: string;
  tags: string[];
}

export const reports: Report[] = [
  {
    id: 'r001',
    title: '某连锁蛋糕店被曝使用过期奶油，监管部门已介入调查',
    summary: '多名消费者反映在该连锁品牌购买的生日蛋糕食用后出现不适。17爆料收到线索后实地核查，发现后厨存在使用过期原料问题，目前监管部门已责令停业整改。',
    category: 'food',
    categoryLabel: '食品安全',
    date: '2026-09-04',
    readTime: 4,
    isHot: true,
    isFeatured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Bakery%20shop%20interior%20with%20cake%20display%20counter%2C%20warm%20yellow%20light%2C%20clean%20professional%20food%20establishment%2C%20editorial%20documentary%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20contrast%20warm%20tones%2C%20neutral%20beige%20and%20cream%20background&width=1200&height=700&seq=rpt-food-001&orientation=landscape',
    imageAlt: '连锁蛋糕店食品安全问题曝光现场',
    tags: ['食品安全', '过期食材', '消费维权', '监管介入'],
    content: '多名消费者通过17爆料私信渠道反映，位于城区多处的「甜蜜时光」连锁蛋糕店存在使用过期奶油的问题。据一位从业者投稿透露，该品牌部分门店为压缩成本，将临期奶油重新贴标使用，并要求员工对此保持沉默。\n\n17爆料编辑部收到线索后，于2026年8月底联系了5名曾在该店购买蛋糕后出现不适的消费者，并于9月初进行了实地暗访核查，拍摄到了疑似过期原料的实物照片。\n\n我们将相关证据向当地市场监督管理局进行了举报。截至发稿，该连锁品牌三处门店已被责令停业整改，监管部门表示将对同品牌全市门店展开专项检查。\n\n编辑部提示：消费者在购买烘焙类食品时，可要求商家出示原材料保质期凭证。如发现食品安全问题，可拨打12315进行投诉举报。',
  },
  {
    id: 'r002',
    title: '小区物业违规收取装修押金拒不退还，业主维权路艰难',
    summary: '某小区数十名业主反映，物业公司以保证金名义收取5000元至20000元不等，装修完成后以各种理由拒绝退款，涉及金额超过百万元。',
    category: 'property',
    categoryLabel: '物业纠纷',
    date: '2026-09-02',
    readTime: 5,
    isHot: true,
    isFeatured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Residential%20apartment%20building%20entrance%20with%20property%20management%20office%2C%20urban%20China%2C%20documentary%20style%2C%20overcast%20natural%20light%2C%20aged%20concrete%20facade%2C%20neutral%20gray%20and%20beige%20tones%2C%20editorial%20photo&width=1200&height=700&seq=rpt-property-002&orientation=landscape',
    imageAlt: '业主集体维权物业纠纷现场',
    tags: ['物业纠纷', '违规收费', '业主维权', '押金退还'],
    content: '自2025年起，多名业主陆续向17爆料反映，某楼盘物业管理公司在装修期间以「装修保证金」名义收取5000至20000元不等的费用，并承诺装修结束无损坏即可退还。然而业主装修完工后，物业以各种理由拒绝全额退款甚至拒不退款。\n\n经17爆料汇总，已有37名业主提供了缴费凭证，涉及金额累计约125万元。\n\n我们联系了当地住建部门及业主委员会，了解到该物业收取「装修保证金」行为在当地政策层面缺乏明确授权，属于违规自设收费项目。目前，业主委员会已委托律师代理集体诉讼事宜。',
  },
  {
    id: 'r003',
    title: '网络刷单平台诈骗升级：从小额试单到大额锁仓',
    summary: '近期收到多位受骗者私信，反映参与网络刷单后陷入任务锁仓陷阱，累计损失从数千元到十数万元不等，涉案平台已在多地被警方关注。',
    category: 'digital',
    categoryLabel: '网络欺诈',
    date: '2026-08-30',
    readTime: 6,
    isHot: false,
    isFeatured: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20looking%20at%20smartphone%20screen%20with%20suspicious%20chat%20messages%2C%20dim%20room%20ambient%20light%2C%20dark%20moody%20editorial%20photography%2C%20beige%20and%20dark%20charcoal%20tones%2C%20documentary%20journalism%20style%2C%20high%20contrast&width=1200&height=700&seq=rpt-digital-003&orientation=landscape',
    imageAlt: '网络刷单诈骗套路图解说明',
    tags: ['网络欺诈', '刷单诈骗', '防骗提示', '警方提示'],
    content: '「先做几单小额任务，立刻返佣，我当时觉得真实可信。」这是多位受骗者在17爆料私信中描述的共同开场白。\n\n近两个月，编辑部累计收到来自11个省市的58条关于「网络刷单诈骗」的线索私信，诈骗模式高度一致：受害者先完成小额刷单并顺利拿到佣金，随后被引导至高额「连单任务」，要求一次性垫付更大金额。一旦支付，平台便以「任务未完成」「账号异常」为由拒绝提现并要求继续充值，直至受害者察觉受骗。\n\n请记住：正规兼职不需要提前垫付本金。遇到此类情况立即停止操作，拨打96110反诈热线。',
  },
  {
    id: 'r004',
    title: '某品牌充电桩运营商暗升价格，老用户毫不知情',
    summary: '多位新能源车主反映，某第三方充电桩运营商在未提前告知的情况下调整计费方式，月底账单比往常高出30%以上，客服回应含糊。',
    category: 'consumer',
    categoryLabel: '消费维权',
    date: '2026-08-28',
    readTime: 3,
    isHot: false,
    isFeatured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Electric%20vehicle%20charging%20station%20in%20parking%20lot%2C%20daytime%2C%20clean%20minimalist%20urban%20environment%2C%20documentary%20photography%20style%2C%20warm%20neutral%20background%2C%20editorial%20composition&width=800&height=520&seq=rpt-ev-004&orientation=landscape',
    imageAlt: '新能源充电桩计费争议现场',
    tags: ['消费维权', '价格欺诈', '充电桩', '新能源'],
    content: '多位车主私信17爆料反映，某品牌充电桩App在未向用户发送任何通知的情况下，于8月将原有「按度计费」悄然改为「按次+度」混合计费，导致单次充电费用上涨15%至35%不等。\n\n我们对比了受害车主提供的7月和8月账单截图，确认价格变动属实，且App版本更新日志中没有相关说明。\n\n根据《消费者权益保护法》相关规定，经营者调整收费标准应提前以显著方式告知消费者。我们已将该事件反映至当地消费者协会，建议相关车主保留账单截图，通过投诉途径申请退差价。',
  },
  {
    id: 'r005',
    title: '景区餐厅收费消毒餐具卫生堪忧，水渍污迹触目惊心',
    summary: '消费者发现某公园景区内餐厅收取消毒餐具费后，实际提供的餐具卫生状况令人担忧，相关图片在网络引发广泛关注。',
    category: 'food',
    categoryLabel: '食品安全',
    date: '2026-08-25',
    readTime: 3,
    isHot: false,
    isFeatured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Restaurant%20table%20setting%20with%20wrapped%20disposable%20utensils%20in%20scenic%20park%20restaurant%2C%20natural%20daylight%2C%20warm%20editorial%20photography%2C%20close%20up%20documentary%20composition%2C%20beige%20and%20warm%20neutral%20tones&width=800&height=520&seq=rpt-food-005&orientation=landscape',
    imageAlt: '景区餐厅消毒餐具卫生疑点',
    tags: ['食品安全', '餐具卫生', '景区消费', '维权'],
    content: '来自17爆料投稿的一组图片显示，某城市公园内景区餐厅向消费者收取每人3元「消毒餐具服务费」后，实际提供的独立包装餐具内部存在明显水渍和污迹，消毒状态存疑。\n\n拍摄者表示当场与餐厅负责人交涉，对方以「仅是包装运输中的水分」搪塞，并拒绝退费或更换。\n\n17爆料已将该线索提交至当地卫生监督所，卫生部门表示将联合市场监管部门对该景区内餐饮单位展开专项检查。',
  },
  {
    id: 'r006',
    title: '小区路灯故障三个月无人修，夜间老人屡次摔伤',
    summary: '某小区路灯大面积故障近三个月，居民多次向物业和街道办反映无果，已有多位老人因此在夜间绊倒受伤，引发强烈不满。',
    category: 'environment',
    categoryLabel: '公共环境',
    date: '2026-08-22',
    readTime: 3,
    isHot: false,
    isFeatured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20residential%20street%20at%20night%20with%20broken%20street%20lights%2C%20overcast%20sky%2C%20moody%20documentary%20photography%2C%20warm%20amber%20light%20from%20apartment%20windows%2C%20editorial%20composition%2C%20quiet%20neighborhood%20scene&width=800&height=520&seq=rpt-env-006&orientation=landscape',
    imageAlt: '小区路灯故障夜间危险环境',
    tags: ['公共环境', '物业失职', '安全隐患', '居民维权'],
    content: '一位居民通过17爆料投稿渠道上传了一组该小区路灯故障现场图片，并附上了连续三个月向物业公司和街道办反映问题的聊天记录，显示对方均以「已上报」「正在处理」为由拖延解决。\n\n据统计，已有至少4名老年居民在该路段夜间行走时摔倒受伤，其中一位老人腕骨骨折，医疗费用至今未获赔偿。\n\n17爆料将该事件转送至当地城管部门和市政设施管理单位。此后48小时内，该小区路灯抢修工作正式启动，目前已完成主要路段修缮。',
  },
  {
    id: 'r007',
    title: '外卖骑手超速被罚后追讨赔偿，揭开配送规则灰色地带',
    summary: '多名外卖骑手私信反映，因系统派单要求时间紧、路程远，被迫超速违规，但受到交警处罚后，平台和代理商均不承担任何费用。',
    category: 'society',
    categoryLabel: '社会民生',
    date: '2026-08-20',
    readTime: 5,
    isHot: true,
    isFeatured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Food%20delivery%20rider%20on%20electric%20scooter%20in%20busy%20Chinese%20city%20street%2C%20motion%20blur%2C%20urban%20documentary%20photography%2C%20warm%20afternoon%20light%2C%20editorial%20composition%2C%20neutral%20gray%20and%20warm%20amber%20tones&width=800&height=520&seq=rpt-society-007&orientation=landscape',
    imageAlt: '外卖骑手超速罚款劳动权益争议',
    tags: ['社会民生', '劳动权益', '外卖骑手', '平台规则'],
    content: '「系统告诉我还有18分钟送达，但路上距离根本不允许守法骑行按时到达。」来自四个城市的11位外卖骑手通过17爆料私信渠道分享了相似的遭遇。\n\n他们描述的情况高度一致：系统给出的送达时限往往远短于正常行驶所需时间，骑手为避免超时被扣分、被差评，不得不在路口抢灯、超速骑行，结果遭到交警处罚，罚款金额从200元到500元不等。\n\n当骑手向平台或代理商提出补偿申请时，均以「个人违规行为自行承担」为由被拒绝。17爆料就此问题采访了两位劳动法领域律师，均表示现行外卖派单算法对骑手安全和权益的保护存在明显漏洞。',
  },
  {
    id: 'r008',
    title: '交叉路口无保护左转频出险情，居民连续三年反映无改善',
    summary: '某主干道交叉口长期无左转保护信号，早晚高峰险情频发，居民和驾驶员多次向交管部门和市政反映，三年来未见任何改善。',
    category: 'traffic',
    categoryLabel: '交通安全',
    date: '2026-08-18',
    readTime: 3,
    isHot: false,
    isFeatured: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Busy%20urban%20intersection%20in%20China%20with%20heavy%20traffic%2C%20traffic%20signal%20lights%2C%20daytime%20documentary%20photography%2C%20wide%20angle%20editorial%20composition%2C%20warm%20neutral%20tones%2C%20high%20contrast%20light&width=800&height=520&seq=rpt-traffic-008&orientation=landscape',
    imageAlt: '无保护左转路口交通安全隐患',
    tags: ['交通安全', '道路设施', '信号灯', '市政问题'],
    content: '附近多位居民和驾驶员通过17爆料投稿，反映该路口问题已持续三年以上。高峰期直行绿灯期间，左转车辆与对向直行车辆抢行，险情频发，近一年内已发生至少3起轻微碰撞事故。\n\n居民表示曾多次通过市政热线、网上信访系统和交管部门窗口反映，但均未收到实质性回应，路口信号配时至今未作任何调整。\n\n17爆料将汇总的居民反映材料和现场视频转送至当地交通管理局。目前交管部门已作出初步回应，表示将在下一轮信号配时优化方案中纳入该路口，预计在年底前完成改造评估。',
  },
];